export const button = {
  root: {
    paddingX: '0.8rem',
    paddingY: '0.3rem',
  },
  colorScheme: {
    dark: {
      root: {
        primary: {
          color: '{surface.0}',
          hoverColor: '{surface.0}',
          activeColor: '{surface.0}',
        },
        secondary: {
          background: '{surface.100}',
          hoverBackground: '{surface.200}',
          activeBackground: '{surface.300}',
          borderColor: '{surface.100}',
          hoverBorderColor: '{surface.200}',
          activeBorderColor: '{surface.300}',
          color: '{surface.600}',
          hoverColor: '{surface.700}',
          activeColor: '{surface.800}',
          focusRing: {
            color: 'transparent',
            shadow: '0 0 0 0.2rem {surface.200}',
          },
        },
        warn: {
          color: '{surface.0}',
          hoverColor: '{surface.0}',
        },
        info: {
          color: '{surface.0}',
          hoverColor: '{surface.0}',
        },
      },
    },
  },
}
